export const REQUEST_ACTION_SUFFIX = "_REQUEST";
export const SUCCESS_ACTION_SUFFIX = "_SUCCEDED";
export const FAILED_ACTION_SUFFIX = "_FAILED";
